import type { GlobalSearchResult, ModuleSearchAdapter } from "../types";
import { getSearchClient } from "../apiClient";

interface ChatSearchMessage {
  id: string;
  body: string;
  created_at: string;
  author: { name: string };
  conversation: { id: string; name: string };
}

interface ChatSearchResponse {
  results: ChatSearchMessage[];
}

function mapMessage(m: ChatSearchMessage): GlobalSearchResult {
  return {
    id: `chat:${m.id}`,
    moduleId: "chat",
    title: m.body,
    subtitle: `#${m.conversation.name} · ${m.author.name}`,
    timestamp: m.created_at,
    href: `/chat/c/${m.conversation.id}?focus=${m.id}`,
  };
}

export const chatAdapter: ModuleSearchAdapter = {
  moduleId: "chat",
  label: "Chat",
  async search(q, signal) {
    const res = await getSearchClient().get<ChatSearchResponse>(
      `/api/chat/search/messages/?q=${encodeURIComponent(q)}&page_size=3`,
      { signal },
    );
    return res.results.map(mapMessage);
  },
};
